export const bridVote = async (id, idGroup, callback = () => { }) => {
    const fetchUrl = `${window.API_HOST}/pwa-brid-vote/`;
    const fd = new FormData();

    fd.set("articleId", `${id}`);
    fd.set("articlesGroup", JSON.stringify(idGroup));

    const data = await (await fetch(fetchUrl, {
        method: 'POST',
        body: fd
    })).json();

    return data
}